const { debounce } = window.BAO.Utils
const { useInitialised } = window.BAO.Carousel.plugins

class FeaturedColumns extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.debouncedHandleResize = debounce(this.handleResize.bind(this), 250)
    
    if (this.dataset.featuredColumnsEl === 'mobile-layout-carousel' && window.BAO.MediaBreakpoints.isXsViewport) {
      this.carousel = this.setupCarousel()
    }
    
    this.setupListeners()
  }

  setupListeners () {
    window.addEventListener('resize', this.debouncedHandleResize)
  }

  disconnectedCallback () {
    window.removeEventListener('resize', this.debouncedHandleResize)
    super.disconnectedCallback?.()
  }

  handleResize () {
    if (this.dataset.featuredColumnsEl === 'mobile-layout-carousel' && window.BAO.MediaBreakpoints.isXsViewport) {
      if (this.carousel) {
        this.carousel.destroy()
      }
      this.carousel = this.setupCarousel()
    } else {
      if (this.carousel) {
        this.carousel.destroy()
      }
      
      this.carousel = null
    }
  }

  setupCarousel () {
    if (! window.BAO.MediaBreakpoints.isXsViewport) return

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1.15,
          spacing: 1,
        }
      },
      [
        useInitialised()
      ],
    )
  }
}

if (!customElements.get('featured-columns')) {
  customElements.define('featured-columns', FeaturedColumns)
}
